import { render, staticRenderFns } from "./GenericFaqDomains.vue?vue&type=template&id=47e4d9c3&scoped=true"
import script from "./GenericFaqDomains.vue?vue&type=script&lang=js"
export * from "./GenericFaqDomains.vue?vue&type=script&lang=js"
import style0 from "./GenericFaqDomains.vue?vue&type=style&index=0&id=47e4d9c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4d9c3",
  null
  
)

export default component.exports